// extracted by mini-css-extract-plugin
export default {"ctaSidebar":"CtaSidebar_ctaSidebar__dWUbu","buttonGroup":"CtaSidebar_buttonGroup__lMouA","icon":"CtaSidebar_icon__HX7Q5"};